module.exports = __webpack_public_path__ + "static/img/home_index4_icon3.47e90b27.png";